import { useEffect } from 'react';
import { promotionsActions } from '@namespace/promotions/src/store'; // I had to do this to avoid cyclic dependency
import { useIsAddictedUser } from '@namespace/user';

export const useGetPromotionTournamentWidgetData = (widgetsList = []) => {
  const isAddictedUser = useIsAddictedUser();

  const { FETCH_PROMOTIONS, RESET_TOURNAMENTS_SERVICE_INFO } =
    promotionsActions;

  const isTournamentIdExists = widgetsList.some(
    (widget) => widget.type === 'tournament' && widget.tournamentId
  );

  useEffect(() => {
    if (!isAddictedUser && isTournamentIdExists) {
      FETCH_PROMOTIONS();
    }

    return () => {
      RESET_TOURNAMENTS_SERVICE_INFO();
    };
  }, []);
};
